// extracted by mini-css-extract-plugin
module.exports = {"cardImgL":"CardImgL_cardImgL__hWNYm"};